import { render, staticRenderFns } from "./OnboardingPage.vue?vue&type=template&id=64620565&"
import script from "./OnboardingPage.vue?vue&type=script&lang=js&"
export * from "./OnboardingPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ganttpro/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64620565')) {
      api.createRecord('64620565', component.options)
    } else {
      api.reload('64620565', component.options)
    }
    module.hot.accept("./OnboardingPage.vue?vue&type=template&id=64620565&", function () {
      api.rerender('64620565', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/views/onboarding/OnboardingPage.vue"
export default component.exports